import { Link } from "react-router-dom";
import { StatusBadge } from "../utils/tableUtils";

const formatTime = (iso) => {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
    timeZone: "Europe/London",
  });
};

const OrdersTable = ({ headers, data = [] }) => {
  return (
    <div className="border-2 border-t-4 border-quaternary bg-[#F7F9F8] text-[#413F3F] overflow-x-auto relative rounded-xl h-full px-3">
      <div className="w-full rounded-t-lg">
        <table className="w-full table-auto divide-y divide-gray-200">
          <thead>
            <tr>
              {headers.map((header, index) => (
                <th
                  key={index}
                  className="text-start text-[13px] font-bold leading-5 px-3 py-1 h-12 whitespace-nowrap"
                >
                  {header}
                </th>
              ))}
              <th className="w-24"></th>
            </tr>
          </thead>
          {data.length > 0 ? (
            <tbody className="divide-y divide-[#8D8D8D]">
              {data.map((item, index) => (
                <tr
                  key={item?._id || index}
                  className={index % 2 === 0 ? "bg-gray-100" : ""}
                >
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {item?.orderId || "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium">
                    <StatusBadge status={item?.status} />
                  </td>
                  <td className="px-3 py-3 text-sm font-medium capitalize max-w-[140px] truncate">
                    {item?.outlet || "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium capitalize max-w-[120px] truncate">
                    {item?.customer_name || "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium capitalize max-w-[120px] truncate">
                    {item?.driver || "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {item?.driver_income != null ? `£${item.driver_income}` : "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {item?.ee_share != null ? `£${item.ee_share}` : "£0"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {item?.delivery_charge != null ? `£${item.delivery_charge}` : "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium text-center">
                    {item?.items_count ?? "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {formatTime(item?.order_time)}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium whitespace-nowrap">
                    {item?.status === "Delivered"
                      ? formatTime(item?.delivery_time)
                      : "—"}
                  </td>
                  <td className="px-3 py-3 text-sm font-medium">
                    <Link
                      to={`/orders/${item?._id}`}
                      className="bg-quaternary text-white font-semibold block px-4 py-1 text-xs rounded-md shadow-md whitespace-nowrap text-center"
                    >
                      Details
                    </Link>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan={headers.length + 1}
                  className="px-3 py-8 italic text-sm font-medium text-center text-gray-500"
                >
                  No orders found for the selected filters.
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </div>
  );
};

export default OrdersTable;
